import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useSelector } from 'react-redux';

const BankDetailsTable = () => {

     const  {eoiCampaignDetails} = useSelector((state) => state.voucherForm);

    return (
        <TableContainer sx={{ overflowX: "auto", mb: 3 }}>
            <Table
                sx={{
                    '& td, & th': {
                        border: '1px solid #E0E0E0',
                    },
                }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: "50%" }}>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                Name of the Bank
                            </Typography>
                        </TableCell>
                        <TableCell sx={{ width: "50%" }}>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {eoiCampaignDetails?.accountDetails?.bankName}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>Account Name</TableCell>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>{eoiCampaignDetails?.accountDetails?.accountName}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>Account Number</TableCell>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>{eoiCampaignDetails?.accountDetails?.accountNumber}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>Transfer within India kindly use this IFSC Code</TableCell>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>{eoiCampaignDetails?.accountDetails?.ifscCode}</TableCell>
                    </TableRow>
                    {eoiCampaignDetails?.accountDetails?.swiftCode && <TableRow>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>Transfer from Outside India kindly use this Swift Code</TableCell>
                        <TableCell sx={{ fontSize: '14px', fontWeight: 500 }}>{eoiCampaignDetails?.accountDetails?.swiftCode}</TableCell>
                    </TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default BankDetailsTable